/* Tarjeta de precio del PDP — sincronización con la variante seleccionada.

   Qué arregla: TODO el bloque de compra (badge de stock, estado de la píldora
   normal/consulta/sinstock, precio base, MOQ, tope de cantidad y tramos de
   volumen) se deriva en SSR de `product.selected_or_first_available_variant`.
   Al cambiar de variante SIN cambiar de producto, `product-info.js` (Dawn) sólo
   trasplanta los nodos cuyos ids conoce —`#price`, `#Sku`, `#Inventory`,
   `#Volume`, `#Price-Per-Item`—, y ninguno existe en este PDP a medida: la
   tarjeta se quedaba congelada en la variante con la que se pintó la página.
   Efecto visible: un producto cuya primera variante tiene 0 uds mostraba
   "Disponible bajo pedido" en todas sus variantes (aunque la elegida tuviera
   stock), y uno cuya primera variante tiene 20 uds mostraba "En stock · 20 uds"
   en todas ellas.

   Cómo: `product-info.js` ya se trae el HTML de la sección re-renderizada con la
   variante seleccionada y lo publica en `PUB_SUB_EVENTS.variantChange`. Aquí se
   recorta de ese documento la tarjeta (`#PriceCard-<section.id>`) y se sustituye
   la del DOM. El SSR sigue siendo la única fuente de verdad: cero lógica de
   stock/precio/MOQ duplicada en JS. Mismo enfoque que
   `assets/surisa-product-gallery.js` — no se toca la fontanería de Dawn.

   Al reemplazar el nodo, `<surisa-volume-pricing>` y el `<product-form>` que
   lleva dentro se re-instancian (connectedCallback / constructor) con los datos
   de la variante nueva. La suscripción vive a nivel de módulo —no en el nodo—,
   así que sobrevive a todos los reemplazos. */
(function () {
  if (window.__surisaPdpPriceCardSync) return;
  window.__surisaPdpPriceCardSync = true;

  var CARD_ID_PREFIX = 'PriceCard-';

  /* El `sectionId` del evento es `data-original-section` (quick add) o
     `data-section`; los ids del DOM vivo se construyen siempre con el
     `section.id` que renderizó la página, es decir `data-section`. */
  function hostFor(sectionId) {
    return (
      document.querySelector('product-info[data-original-section="' + sectionId + '"]') ||
      document.querySelector('product-info[data-section="' + sectionId + '"]')
    );
  }

  /* Cantidad tecleada por el usuario, para no perderla al cambiar de variante.
     Se devuelve sólo si el stepper estaba operativo (en consulta/sinstock va
     readonly y su valor no significa nada). */
  function pickQuantity(card) {
    var input = card.querySelector('[data-qty]');
    if (!input || input.readOnly || input.disabled) return null;
    var v = parseInt(input.value, 10);
    return isNaN(v) ? null : v;
  }

  /* Re-aplica la cantidad sobre la tarjeta nueva. El `change` deja que
     <surisa-volume-pricing> la cape al MOQ/stock de la variante entrante y
     recalcule precio/ud, total y tramo activo. */
  function restoreQuantity(card, qty) {
    if (qty == null) return;
    var input = card.querySelector('[data-qty]');
    if (!input || input.readOnly || input.disabled) return;
    input.value = String(qty);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function sync(payload) {
    if (!payload || !payload.html || !payload.sectionId) return;

    var host = hostFor(payload.sectionId);
    if (!host) return;

    var source = payload.html.getElementById(CARD_ID_PREFIX + payload.sectionId);
    var destination = document.getElementById(CARD_ID_PREFIX + host.dataset.section);
    if (!source || !destination) return;

    var qty = pickQuantity(destination);
    var fresh = document.importNode(source, true);
    /* El id del render remoto puede venir con el section id original (quick
       add); se conserva el del DOM vivo para que el siguiente cambio de
       variante siga encontrando la tarjeta. */
    fresh.id = destination.id;
    fresh.setAttribute('data-section', destination.getAttribute('data-section'));

    destination.replaceWith(fresh);
    restoreQuantity(fresh, qty);
  }

  /* `subscribe` y `PUB_SUB_EVENTS` son globales de pubsub.js / constants.js,
     cargados con defer en el <head> → ya están definidos cuando corre este
     fichero. Se comprueban igualmente para no romper si el PDP se usara en una
     plantilla que no los cargue. */
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    sync(event && event.data);
  });
})();
